import script from "./AboutUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutUs.vue?vue&type=script&setup=true&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=3ebf150a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ebf150a"]])

export default __exports__